import React from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/components/auth/AuthProvider";
import { useGuestSaves } from "@/hooks/use-guest-saves";
import { useNavigate } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { analytics } from "@/lib/analytics";

export function GuestSavesIndicator() {
  const { user } = useAuth();
  const { guestSaves } = useGuestSaves();
  const navigate = useNavigate();
  
  const savedCount = guestSaves.length;

  if (savedCount === 0) return null;

  const handleClick = () => {
    analytics.viewSavedList(savedCount, !!user);
    navigate("/favorites");
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClick}
            className="relative text-red-500 hover:text-red-600 hover:bg-red-50"
          >
            <Heart className="h-4 w-4 mr-1 fill-current" />
            <span className="hidden sm:inline">Saved</span>
            <Badge 
              variant="secondary" 
              className="ml-1 bg-red-500 text-white hover:bg-red-500"
            >
              {savedCount}
            </Badge>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {user 
            ? "View your saved nursing homes" 
            : "Sign in to save your list across devices"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}